import {Input} from '@main/components/form/form-field/input';

/** Класс для поля ввода даты. */
export class DateInput extends Input {
  /**
   * Конструктор класса.
   *
   * @param {object} props Параметры компонента.
   */
  constructor(props) {
    super(props);
    this.bindEventListeners();
  }

  /**
   * Прослушиваем события в инпуте с датой.
   *
   * @returns {void}
   */
  bindEventListeners() {
    super.bindEventListeners();
    this.input.addEventListener('keydown', this.onKeyDown.bind(this));
    this.input.addEventListener('paste', this.onPaste.bind(this));
  }

  /**
   * Применение маски к дате при вводе.
   *
   * @param {Event} e Событие, происходящее при вводе в инпуте.
   * @returns {void}
   */
  onInput(e) {
    this.applyDateFormat();
    super.onInput();
  }

  /**
   * Применяет формат даты dd.mm.yyyy.
   *
   * @returns {void}
   */
  applyDateFormat() {
    const cursorPosition = this.input.selectionStart;

    // Сохраняем только цифры
    const cleanedValue = this.input.value.replace(/\D/g, '');

    // Применяем маску формата dd.mm.yyyy
    let formattedValue = '';
    for (let i = 0; i < cleanedValue.length; i++) {
      if (i === 2 || i === 4) {
        formattedValue += '.';
      }
      if (i >= 8) break; // Ограничиваем длину
      formattedValue += cleanedValue[i];
    }

    // Обновляем значение
    this.input.value = formattedValue;

    // Восстанавливаем позицию курсора
    this.restoreCursorPosition(cursorPosition, cleanedValue.length);
  }

  /**
   * Восстанавливает позицию курсора после форматирования.
   *
   * @param {number} originalPos Исходная позиция курсора.
   * @param {number} digitsLength Количество введенных цифр.
   * @returns {void}
   */
  restoreCursorPosition(originalPos, digitsLength) {
    let newPosition = originalPos;

    // Корректируем позицию курсора при добавлении точек
    if (digitsLength >= 2 && originalPos > 2) newPosition++;
    if (digitsLength >= 4 && originalPos > 5) newPosition++;

    this.input.setSelectionRange(newPosition, newPosition);
  }

  /**
   * Колбэк обработки события нажатия клавиш.
   *
   * @param {KeyboardEvent} e Событие клавиатуры.
   * @returns {void}
   */
  onKeyDown(e) {
    // Разрешаем управляющие клавиши
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'Home',
      'End',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
    ];

    // Разрешаем Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
    if (e.ctrlKey && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
      return;
    }

    // Разрешаем цифры
    const isDigit = /^\d$/.test(e.key);

    // Разрешаем управляющие клавиши
    if (allowedKeys.includes(e.key)) {
      return;
    }

    // Запрещаем все остальное
    if (!isDigit) {
      e.preventDefault();
    }
  }

  /**
   * Обработка вставки текста.
   *
   * @param {ClipboardEvent} e Событие вставки.
   * @returns {void}
   */
  onPaste(e) {
    e.preventDefault();

    // Получаем текст из буфера обмена
    const pastedText = e.clipboardData.getData('text');

    // Очищаем от нецифровых символов
    const cleanedText = pastedText.replace(/\D/g, '');

    // Вставляем очищенный текст
    this.input.value = cleanedText;

    // Применяем форматирование
    this.applyDateFormat();

    this.updateIsFilledStatus();
  }
}
